export default "__VITE_ASSET__Dl2f4lgV__"